<template>
    <b-tab title="ประวัติการใช้งาน">
        <b-row>
            <b-col cols="12" class="my-2">
                <b-row class="align-items-center">
                    <b-col cols="8">
                        <h3>ประวัติการใช้งาน</h3>
                    </b-col>
                    <b-col cols="4">
                        <b-form-input
                            v-model="searchTerm"
                            placeholder="ค้นหาชื่อพนักงาน"
                            @input="onSearchInput"
                        >
                        </b-form-input>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col cols="12">
                <b-table
                    responsive
                    :fields="fields"
                    :items="historys"
                >
                    <template #cell(driver)="data">
                        <div v-if="data.item.driver">
                            {{ `${data.item.driver.firstname} ${data.item.driver.lastname}` }} 
                            <small>({{data.item.driver.email}})</small>
                            <!-- <b-badge :variant="getStatusCarBadgeVariant(carDetails.status).color">
                                {{getStatusCarBadgeVariant(carDetails.status).title}}
                            </b-badge> -->
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="d-flex justify-content-end">
                <b-pagination
                    v-model="pagination.currentPage"
                    :disabled="isLoading"
                    :total-rows="pagination.totalRows"
                    :per-page="pagination.perPage"
                    aria-controls="my-table"
                    class="mt-3"
                    @change="(page) => getHistoryCar(page)"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-tab>
</template>

<script>
import carServices from "@/api/car.service.js";
import { getCancelToken } from "@/util/axiosCancel";
import createDebouncedFunction from "@/util/debounce.js";

export default {
    props:{
        historyDetails: {
            type: Object
        }
    },
    data() {
        return {
            isLoading: false,
            pagination: {
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
            },
            searchTerm: '',
            historys: [],
            fields: [
                {
                    key: "driver",
                    label: "ผู้ขับ",
                },
                {
                    key: "created_date",
                    label: "วันที่เริ่มใช้",
                    class: "text-center",
                    formatter: (value) => {
                        if (!value) return "";

                        const date = new Date(value);

                        const formattedDate = date.toISOString().split("T")[0];

                        const formattedTime = date
                        .toTimeString()
                        .split(" ")[0]
                        .substring(0, 5);

                        return `${formattedDate} ${formattedTime}`;
                    },
                }
            ]
        }
    },
    mounted(){
        this.getHistoryCar();
    },
    methods:{
        onSearchInput: createDebouncedFunction(function() {
            this.getHistoryCar();
        }, 500),
        async getHistoryCar(page = 1) {
            this.isLoading = true;
            this.$emit('update:isLoadPage', true)

            try {
                const cancelToken = getCancelToken();
                const response = await carServices.getHistoryCarById({
                        page,
                        vehicle_type_id: this.$route.params.id,
                        filters: this.searchTerm,
                    },
                    cancelToken
                );

                this.historys = response.data.data.items;
                this.pagination.totalRows = response.data.data.meta.totalItems;
                this.pagination.perPage = response.data.data.meta.itemsPerPage;
                this.pagination.currentPage = response.data.data.meta.currentPage;

            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
                this.$emit('update:isLoadPage', false)
            }
        },
    }
}
</script>
